import React from 'react';
import { pathname } from '../../utils';
import Header from '../misc/Header';
import NoContent from '../misc/Message';
import SubHeader from '../misc/SubHeader';
import PaymentsTable from './PaymentsTable';

export default function Layout(props) {
  const { payments, setLoading, setPayments, debit, onGoingPayments } = props;
  return (
    <React.Fragment>
      <Header header={pathname.remittance.label} />
      {payments.length === 0 && (
        <NoContent text="It looks like you don't have an approved Growth Plan yet. If you've submitted an application, we'll get back to you soon." />
      )}
      {payments.length > 0 && (
        <React.Fragment>
          <SubHeader
            width={700}
            text={`If you need to make a change to your ${pathname.remittance.label}, please submit a request through the Line Lab. If you have questions, please contact us.`}
          />
          <PaymentsTable
            payments={payments}
            debit={debit}
            onGoingPayments={onGoingPayments}
            setLoading={setLoading}
            setPayments={setPayments}
            splitPaymentTable={true}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
